import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Создаем красную иконку для маркера
const redIcon = new L.Icon({
  iconUrl: 'data:image/svg+xml;base64,' + btoa(`
    <svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 0C5.596 0 0 5.596 0 12.5c0 9.375 12.5 28.5 12.5 28.5s12.5-19.125 12.5-28.5C25 5.596 19.404 0 12.5 0z" fill="#27407c"/>
      <circle cx="12.5" cy="12.5" r="6" fill="white"/>
    </svg>
  `),
  iconSize: [25, 41],
  iconAnchor: [12.5, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const RussiaMap = () => {
  const cities = [
    {
      name: 'Москва',
      position: [55.7558, 37.6173],
      consoleText: 'Hello World Moscow'
    },
    {
      name: 'Екатеринбург',
      position: [56.8389, 60.6057],
      consoleText: 'Hello World Ekatirinburg'
    },
    {
      name: 'Хабаровск',
      position: [48.4827, 135.0838],
      consoleText: 'Hello World Habarovsk'
    }
  ];

  const handleMarkerClick = (consoleText) => {
    console.log(consoleText);
  };

  return (
    <MapContainer
      center={[61.524, 100.3188]}
      zoom={4}
      style={{ height: '100vh', width: '100%' }}
    >
      {/* Светлая тема карты (CartoDB Positron) */}
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
      />
      
      {cities.map((city, index) => (
        <Marker
          key={index}
          position={city.position}
          icon={redIcon}
          eventHandlers={{
            click: () => handleMarkerClick(city.consoleText)
          }}
        >
          <Tooltip 
            permanent={true} 
            direction="top" 
            offset={[0, -40]}
            className="city-label"
          >
            {city.name}
          </Tooltip>
          <Popup>{city.name}</Popup>
        </Marker>
      ))}
    </MapContainer>
  );
};

export const MapComponent = () => {
    return(
        <RussiaMap/>
    )
}